// eslint-disable-next-line
import { useEffect, useState } from "react";
import "./App.css";
import Home from "./Page/home/home";
import api from "./api/api";
import GetConfigWhiteLabel from "./services/GetWhiteLabel";
import { WhiteLabelContext, WhiteLabelProvider } from "../src/context/index";
import GlobalState from "./globalState/globalState";

function App() {
  const [accessTokenGS, setAccessTokenGS] = useState("");
  const [moduleID, setModuleID] = useState(0);
  const [ambiente, setAmbiente] = useState("");
  const [baseURLWB, setBaseURLWB] = useState("");
  const [apiCodeWB, setApiCodeWB] = useState("");
  const [firstProduct, setFirstProduct] = useState("");
  const [mostraPrecoCheio, setMostraPrecoCheio] = useState("");
  const [ready, setReady] = useState(false);
  let [planoPag, setPlanoPag] = useState("");

  useEffect(() => {
    const logar = async () => {
      try {
        let apiCodeWB;

        let configWhitelabel = await GetConfigWhiteLabel();
        if (configWhitelabel) {
            setModuleID(configWhitelabel.moduleID ?? 4);
          setBaseURLWB(configWhitelabel.urlApi);
          setApiCodeWB(configWhitelabel.apiCode);
          apiCodeWB = configWhitelabel.apiCode;
          setAmbiente(configWhitelabel.ambiente);
          setFirstProduct(configWhitelabel.rubricaDestaque);
          setMostraPrecoCheio(configWhitelabel.mostraPrecoCheio);
          const resp = await api.post("ws_loginaplicacao/", {
            clapi_vcds_code: apiCodeWB,
          });
          setAccessTokenGS(resp.data.detalhe.access_token);
          planoPagamento(resp.data.detalhe.access_token);
        }
      } catch (err) {
        console.log(err);
      }
    };
    const planoPagamento = async (access_token: string) => {
      const resp = await api.get("ws_planopagamento/", {
        headers: { Authorization: `Bearer ${access_token}` },
      });
      setPlanoPag(resp.data.detalhe[0][0].plpag_vcds_planopagamento);
    };
    const scroll = (hash: string) => {
      if (
        document.querySelector(`${hash}`) === undefined ||
        document.querySelector(`${hash}`) === null
      ) {
        setTimeout(() => {
          scroll(hash);
        }, 1000);
      } else {
        let hashName = document.querySelector(`${hash}`);
        hashName?.scrollIntoView();
      }
    };
    if (window.location.hash) {
      let hash = window.location.hash;
      scroll(hash);
    }
    logar();
  }, []);

  useEffect(() => {
    if (accessTokenGS !== "") {
      setReady(true);
    }
  }, [accessTokenGS]);

  return (
    <div className="App">
      <GlobalState.Provider
        value={{
          accessTokenGS,
          ambiente,
          planoPag,
          firstProduct,
          mostraPrecoCheio,
          moduleID,
          baseURLWB,
          apiCodeWB,
        }}
      >
        <WhiteLabelProvider value={WhiteLabelContext}>
          {ready ? <Home /> : null}
        </WhiteLabelProvider>
      </GlobalState.Provider>
    </div>
  );
}

export default App;
